/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentData, ComponentModel, ComponentFieldKey } from '../model/component.model';
import { Alignment } from '../model/alignment.model';
import { ViewComponentKey } from '../key/view-component.key';

export class TextFieldKey {
  static readonly TEXT = 'text';
  static readonly TEXT_ARGS = 'textArgs';
  static readonly ALIGNMENT = 'alignment';
}

export interface TextData extends ComponentData {
  text?: string;
  textArgs?: object;
  alignment?: Alignment;
}

export class TextModel extends ComponentModel implements TextData {
  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(TextFieldKey).map((key) => TextFieldKey[key])
  );

  constructor(data?: TextData, keys?: string[]) {
    super(data, keys || TextModel.KEYS);
  }

  get text(): string {
    return this.get(TextFieldKey.TEXT);
  }

  set text(value: string) {
    this.set(TextFieldKey.TEXT, value);
  }

  get textArgs(): object {
    return this.get(TextFieldKey.TEXT_ARGS);
  }

  set textArgs(value: object) {
    this.set(TextFieldKey.TEXT_ARGS, value);
  }

  get alignment(): Alignment {
    return this.get(TextFieldKey.ALIGNMENT);
  }

  set alignment(value: Alignment) {
    this.set(TextFieldKey.ALIGNMENT, value);
  }

  protected setupValues(values: TextData, exclusive: boolean): TextData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.TEXT;
    }
    return super.setupValues(values, exclusive) as TextData;
  }

}
